import { answersOptions } from "Context/answersContext";
import { IFlowItem } from "Flow/types/flow.types";
import { answersMaps } from "Questions/helpers/maps";
import { ElemType } from "Questions/types/question.types";

export const Step6: IFlowItem[] = [
    {
        field: 'fatherConditions',
        titleCond: (answers) => {
            if(answers.iam === 'bio_father') {
                return 'TITLE_FATHERCONDITIONSS_IAM';
            }
            return 'TITLE_FATHERCONDITIONS';
        },
        flex: 'split',
        elem: answersMaps.optionsToElem(answersOptions.conditions, ElemType.Checkbox)
    }
]
